import { render, staticRenderFns } from "./PritickeGummy.vue?vue&type=template&id=1cf642be&scoped=true&"
import script from "./PritickeGummy.vue?vue&type=script&lang=js&"
export * from "./PritickeGummy.vue?vue&type=script&lang=js&"
import style0 from "./PritickeGummy.vue?vue&type=style&index=0&id=1cf642be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf642be",
  null
  
)

export default component.exports